export default __webpack_public_path__ + "static/media/img_introduce_benefit_3.e1903af2.png";